<div class="btn-group join">
  <button (click)="paginate(1)" [disabled]="first" class="btn-primary">First</button>
  <button (click)="paginate(current - 1)" [disabled]="first" class="btn-primary">Previous</button>
  <button
    *ngFor="let page of pageOptions"
    (click)="paginate(page)"
    class="btn-primary"
    [ngClass]="{ active: page === current }"
  >
    {{ page }}
  </button>
  <button (click)="paginate(current + 1)" [disabled]="last" class="btn-primary">Next</button>
  <button (click)="paginate(totalPages)" [disabled]="last" class="btn-primary">Last</button>
</div>
